import isPropValid from '@emotion/is-prop-valid';
import { styled } from '@mui/material';

import { FC } from 'react';

import { Link, LinkProps } from './Link';
import { SuspenseImage } from './SuspenseImage';
import type { SuspenseImageProps } from './SuspenseImage';

const StyledLink = styled(Link)<LinkProps>(props => ({
  '&:focus-visible': {
    borderRadius: props.theme.spacing(0.25),
    outlineOffset: -1
  },
  display: 'inline-flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  maxWidth: props.theme.spacing(460 / 4),
  [props.theme.breakpoints.down('sm')]: {
    /** offset for zendesk button in mobile */
    maxWidth: `calc(100vw - ${props.theme.spacing(64 / 4)})`
  }
}));

const StyledLogo = styled(SuspenseImage, {
  shouldForwardProp: isPropValid
})<NavbarLogoProps>({
  height: 'auto',
  maxHeight: '100%',
  width: 'auto'
});

export type NavbarLogoProps = SuspenseImageProps & {
  external?: boolean;
  to?: string;
};

export const NavbarLogo: FC<NavbarLogoProps> = ({
  external,
  to = '/',
  ...props
}) => {
  return (
    <StyledLink external={external} to={to}>
      <StyledLogo data-defaultsrc='/images/topbar/connect.webp' {...props} />
    </StyledLink>
  );
};

NavbarLogo.displayName = 'NavbarLogo';
